<template>
  <div class="product-item__details">
    <div class="product-item__title-wrapper d-flex justify-between">
      <a
        class="product-item__title body-base no-underline"
        :href="product.context_url"
      >{{ product.title }}</a>
    </div>
    <ProductCardPrice :data="priceData" />
    <div>
    <dd class="swym-plp">
      <!-- Swym Wishlist Plus EPI Button-->
      <button data-with-epi="true" :class="'swym-button swym-add-to-wishlist-view-product product_' + this.product.id" data-swaction="addToWishlist" :data-product-id="this.product.id" :data-variant-id="this.product.variants[0].id" :data-product-url="'https://francesvalentine.com/products/' + this.product.handle"></button>
      <!-- Swym Wishlist Plus EPI Button-->
    </dd>
  </div>
    <ProductCardSwatches :data="swatchesData" />
    <div
      class="yotpo bottomLine"
      :data-product-id="product.id"
    ></div>
  </div>
</template>

<script>
import ProductCardSwatches from './ProductCardSwatches.vue';
import ProductCardPrice from './ProductCardPrice.vue';

export default {
  components: {
    ProductCardSwatches,
    ProductCardPrice,
  },

  props: {
    initialProduct: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
    updateProduct: {
      type: Function,
    },
    onPlp: {
      type: Boolean,
    }
  },

  computed: {
    swatchesData() {
      return {
        colors: this.initialProduct.color_variants,
        current_product: {
          id: this.product.id,
        },
        updateProduct: this.updateProduct,
        onPlp: this.onPlp
      };
    },
    priceData() {
      const isIinitalProduct = this.product.compare_at_price;
      const selectedProductComparePrice = this.product.variants[0].compare_at_price
      const initialCompareAtPrice = isIinitalProduct ? this.product.compare_at_price / 100 : null;
      const initialCompareAtPriceAmount = isIinitalProduct ? this.formatMoney(this.product.compare_at_price / 100) : null;

      const productPrice = this.product.price ? this.product.price / 100 : this.product.variants[0].price
      return {
        price: this.formatMoney(productPrice),
        comparePrice: selectedProductComparePrice ? this.formatMoney(selectedProductComparePrice) : initialCompareAtPriceAmount,
        percentOff: selectedProductComparePrice ? Math.round(100 - (productPrice / selectedProductComparePrice * 100)) : Math.round(100 -(productPrice/ initialCompareAtPrice * 100)),
        product: this.product
      }
    }
  },



  methods: {
    updateYotpoRating() {
      if (window.Yotpo && window.yotpo) {
        const api = new window.Yotpo.API(window.yotpo);
        api.refreshWidgets();
      }
    },
    formatMoney(amount) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(amount);
    }
  },
}
</script>

<style>

</style>